import React from "react";
import NavbarLink from "./NavbarLink";
import { routes } from "../constants/routes";
import { MoonIcon } from "@chakra-ui/icons";

const Navbar = ({ darkBg, lgContainer }) => {
  return (
    <div className={`${lgContainer ? "container-xl" : "container"}`}>
      <div className={`flex py-3`}>
        <div className="flex-1">
          <a
            href={routes.home}
            className={`${
              darkBg && "text-white"
            } text-3xl font-extrabold tracking-tighter`}
          >
            Y<span className="text-blue-500 -ml-1">D</span>
            <span className="-ml-1">C</span>
          </a>
        </div>
        <div className="space-x-6 items-center hidden md:flex">
          <div className="space-x-2 flex items-center">
            <div
              className={`w-1 h-1 p-px rounded-full animate-pulse ${
                darkBg ? "bg-white" : "bg-black"
              }`}
            ></div>
            <NavbarLink
              title="Scratchathon"
              url={routes.scratchathon}
              darkBg={darkBg}
            />
          </div>
          <NavbarLink
            title="Learn Scratch"
            url={routes.learnscratch}
            darkBg={darkBg}
          />
          <NavbarLink title="About" url={routes.about} darkBg={darkBg} />
          <NavbarLink title="Contact" url={routes.contact} darkBg={darkBg} />
        </div>
      </div>
    </div>
  );
};

export default Navbar;
